import { Box, Typography, alpha } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

interface Props {
  faltantes: number;
}

/**
 * Replica `.callout.danger` del diseño de Flux para las empresas sin nombre. El `Callout` del kit
 * solo trae los tonos `warn` y `neutral`, por eso este aviso lleva su propio estilo en rojo.
 */
export const CalloutEmpresasFaltantes = ({ faltantes }: Props) => (
  <Box
    sx={{
      display: "flex",
      gap: 1,
      mb: "10px",
      px: 2,
      py: 1,
      borderRadius: 3,
      border: "1px solid",
      borderColor: (theme) => alpha(theme.palette.error.main, 0.3),
      bgcolor: (theme) => alpha(theme.palette.error.main, 0.06),
    }}
  >
    <InfoOutlined sx={{ fontSize: 14, mt: "3px", color: "error.main" }} />
    <Typography variant="body2" sx={{ color: "error.dark", lineHeight: 1.5 }}>
      {faltantes === 1 ? "Falta el nombre de una empresa" : `Faltan los nombres de ${faltantes} empresas`}. Escríbelo o
      elimina la fila para continuar.
    </Typography>
  </Box>
);
